'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'house-damage';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f6f1';
var svgPathData = 'M573.51 219.94L512 170.35V72c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v72.55L310.63 8.01c-13.16-10.69-32.06-10.69-45.22 0L2.53 219.94c-2.92 2.36-3.37 6.64-1.01 9.45l14.17 17.55a6.788 6.788 0 0 0 9.56 1.01L64 216.7V496c0 8.84 7.16 16 16 16h149.57l-14.55-32-22.69-49.91 104.11-71.99L236.28 224l148.05 153.86-104.11 71.99L299.59 480l20.55 32H496c8.84 0 16-7.16 16-16V216.78l38.79 31.28c2.93 2.36 7.2 1.91 9.56-1.01l14.17-17.55c2.36-2.92 1.8-7.2-1.01-9.56zM480 480H337.63l-13.76-21.42 78.67-54.4a31.976 31.976 0 0 0 13.64-23.13c.94-9.34-2.28-18.62-8.78-25.38L259.34 201.81c-6.22-6.47-14.61-9.81-23.07-9.81-6.2 0-12.44 1.8-17.9 5.48-12.89 8.71-17.66 25.42-11.29 39.62l49.27 109.82-82.22 56.85c-12.73 8.81-17.34 25.47-10.93 39.56L179.87 480H96V190.9L283.74 39.51a6.635 6.635 0 0 1 8.44 0L480 190.98V480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faHouseDamage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;